var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitchBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 46,
    viewBox: "0 0 195 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.121,
    y1: 0.215,
    x2: 0.869,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#febdbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#febaba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    stroke: "#fdc300",
    strokeWidth: 4,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,0H195a0,0,0,0,1,0,0V0a46,46,0,0,1-46,46H0a0,0,0,0,1,0,0v0A46,46,0,0,1,46,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.174,2h149A1.826,1.826,0,0,1,193,3.826v0A40.174,40.174,0,0,1,152.826,44h-149A1.826,1.826,0,0,1,2,42.174v0A40.174,40.174,0,0,1,42.174,2Z",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchBg);
export default __webpack_public_path__ + "static/media/switch-bg.87d010e9af00ac806daeece314bf5594.svg";
export { ForwardRef as ReactComponent };